import React from 'react';
import { Button } from '@/components/ui/button';
import { Plug, RefreshCw, Power, KeyRound } from 'lucide-react';

interface VezgoConnectFormProps {
  onConnect: () => void;
  onRefresh?: () => void;
  onDisconnect: () => void;
  isConnected: boolean;
  provider?: string;
  testToken?: () => void; // Add prop for debug
}

export function VezgoConnectForm({
  onConnect, 
  onRefresh, 
  onDisconnect, 
  isConnected,
  provider,
  testToken
}: any) {
  // Add simple error UI if needed—error handling moved to logic above!
  return (
    <div className="flex flex-col space-y-4">
      <Button 
        onClick={onConnect} 
        className="w-full"
        variant={isConnected ? "outline" : "default"}
      >
        <Plug className="mr-2 h-4 w-4" />
        {isConnected ? "Reconnect" : "Connect"} 
        {provider ? ` ${provider}` : " Provider"}
      </Button>

      {isConnected && (
        <div className="flex space-x-4">
          {onRefresh && (
            <Button 
              onClick={onRefresh} 
              variant="outline" 
              className="flex-1"
            >
              <RefreshCw className="mr-2 h-4 w-4" />
              Refresh Connection
            </Button>
          )}
          <Button 
            onClick={onDisconnect} 
            variant="destructive" 
            className="flex-1"
          >
            <Power className="mr-2 h-4 w-4" />
            Disconnect
          </Button>
        </div>
      )}

      {/* Debug/Test area: Only show if function exists */}
      {typeof testToken === "function" && (
        <Button variant="ghost" className="w-full" onClick={testToken}>
          <KeyRound className="mr-2 h-4 w-4" />
          Test API Token
        </Button>
      )}
    </div>
  );
}
